import { u as r } from "../styled-components.browser.esm-3eb04950.js";
import { Breadcrumb as o } from "antd";
const i = r(o)`
    font-size: 30px;
    margin-bottom: 15px;
    font-weight: 500;
    
    ol > li {
        color: var(--dark-text);
        
        a {
            color: var(--dark-text);
        }       
        
        &:last-child {
            color: var(--primary);

            a:not(:hover){
                color: var(--primary);
            }
        }
    }

    @media (max-width: 1600px) {
        font-size: 14px;
    }

    .ant-breadcrumb-separator {
        color: var(--light-grey-2);
    }
`;
export {
  i as BironBreadcrumb
};
//# sourceMappingURL=BironBreadCrumb.js.map
